<mat-card class="mcd-card">
  <mat-card-header
    class="mcd-card-header"
    style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
    "
  >
    <mat-card-title class="mcd-card-title"
      >Equipment Exception list</mat-card-title
    >
  </mat-card-header>

  <section class="standards-tabs">
    <div class="tab-wrapper">
      <span>
        <img
          src="/assets/images/Standard.svg"
          style="margin-right: 8px"
          height="16"
          width="16"
        />
      </span>
      <mat-checkbox class="tabCheckbox" (change)="tabClick($event)"
        >Standards Exceptions</mat-checkbox
      >
    </div>
    <div class="tab-wrapper" [class.active]="equipmentException">
      <span>
        <img
          src="/assets/images/kitchen-hood 3.svg"
          style="margin-right: 8px"
          height="16"
          width="16"
        />
      </span>
      <mat-checkbox
        [checked]="setEquipmentExceptionCheck()"
        [(ngModel)]="equipmentException"
        class="tabCheckbox"
        >Equipment Exceptions</mat-checkbox
      >
    </div>
  </section>

  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row" *ngIf="userRole != 3">
      <div class="col filter-panel">
        <app-exceptions-filter
          (selectedFilter)="selectedStatuses($event)"
          (searchApplied)="onSearchFromChild($event)"
          [searchKeyFromParent]="searchKey"
          [initialCountryIds]="countryId"
          (countrySelected)="onCountryfromChild($event)"
          (exportListFilter)="handleExport($event)"
          (countryListFilter)="handleCountryList($event)"
        ></app-exceptions-filter>
      </div>
      <!-- <div class="col-md-12 filter-panel">
        <div class="mcd-filter-tag-wrapper">
          <div class="mcd-tag-title">Filter By Exception Status</div>
          <mat-checkbox
            *ngFor="let item of addendumStatuses"
            [checked]="setCheckedStateForCheckBoxes(item.id)"
            (change)="
              addOrRemoveFilter($event, item.id, item.name, 'addendumStatus')
            "
            >{{ item.name }}</mat-checkbox
          >
        </div>
      </div> -->
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="!loading" class="table-wrapper">
      <div>
        <!-- <div class="row">
          <div class="col-6">
            <mat-form-field *ngIf="filteredAddendums.length > 0">
              <mat-select
                [value]="pageSize"
                name="nOfRows"
                #items
                (selectionChange)="selectedItemsPerPageChange($event)"
              >
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            class="col-6 text-right"
            style="display: flex; flex-direction: row-reverse"
          >
            <mat-form-field
              *ngIf="
                userRole == userRoleEnum.GlobalAdmin ||
                userRole == userRoleEnum.AOWAdmin
              "
            >
              <mat-label>Country</mat-label>
              <mat-select
                [value]="selectedCountryId"
                name="dropCategory"
                #country
                (selectionChange)="selectCountry($event)"
              >
                <mat-option
                  *ngFor="let item of countries; let j = index"
                  [value]="item.id"
                  >{{ item.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div> -->
        <div *ngIf="filteredAddendums.length > 0">
          <table class="table nrbes-grid">
            <thead class="thead-light">
              <tr>
                <th scope="col" width="28%">
                  <div class="title-cell-wrapper">
                    <mat-checkbox *ngIf="getSelectableRowsOnPage().length > 0"
                      color="primary"
                      [checked]="isAllOnPageSelected()" [indeterminate]="isSomeOnPageSelected()"
                      (click)="$event.stopPropagation()"
                      (change)="selectAllOnPageChange($event)"></mat-checkbox>
                    <span>Title</span>
                  </div>
                </th>
                <th scope="col-4" width="28%">Description</th>
                <!-- <th scope="col-2">Notes</th> -->
                <th scope="col" width="11%">Country</th>
                <th scope="col" width="11%">Last Updated</th>
                <th scope="col" width="11%">Expired on</th>
                <th scope="col" width="11%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of filteredAddendums"
                (click)="
                  rowSelected(item); addendumService.isCommingFromNrbes = false
                "
              >
                <td
                  class="title-cell"
                  style="font-weight: 500; color: #3949a3; font-size: 14px; padding: 12px;"
                >
                  <div class="title-cell-wrapper">
                    <mat-checkbox
                      color="primary"
                      [checked]="isSelected(item.id)"
                      (click)="$event.stopPropagation()"
                      (change)="onCheckboxChange($event, item.id)"></mat-checkbox>
                    <span class="standard-title-text">{{ item.standard?.title }}</span>
                  </div>
                </td>
                <td class="description">
                  <span title="{{ item.shortDescription }}" class="">
                    {{ item.description }}
                  </span>
                </td>
                <!-- <td class="note-cell">
                  {{ item.note }}
                </td> -->
                <td class="note-cell">
                  {{ item.country[0].name }}
                </td>
                <td class="approval-cell">
                  <!-- <span class="approval-label">Approved / Rejected On</span> -->
                  <span class="approval-value"
                    >{{
                      item.approvedOrRejectedDate
                        ? (item.approvedOrRejectedDate | date: "dd MMMM yyyy")
                        : "--"
                    }}
                  </span>
                </td>
                <td class="approval-cell">
                  <!-- <span class="approval-label">Expiring On</span> -->
                  <span class="approval-value"
                    >{{
                      item.expiryDate
                        ? (item.expiryDate | date: "dd MMM, yyyy")
                        : "--"
                    }}
                  </span>
                </td>
                <td class="status-cell">
                  <span
                    [ngStyle]="
                      getStatusStyle(item.userRoleWiseAddendumStatusName)
                    "
                    style="padding: 5px 8px; border-radius: 16px"
                  >
                    <img
                      [src]="getStatusIcon(item.userRoleWiseAddendumStatusName)"
                      style="margin-right: 5px"
                    />{{ item.userRoleWiseAddendumStatusName }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
            *ngIf="addendums.length > 0"
          >
            <div>
              <div>
                <mat-form-field>
                  <mat-select
                    style="
                      padding: 8px 16px;
                      border: 1px solid #dde1e6;
                      border-radius: 4px;
                      background-color: #f8fafb;
                      color: #4d5258;
                      font-weight: 500;
                    "
                    [value]="pageSize"
                    name="nOfRows"
                    #items
                    (selectionChange)="selectedItemsPerPageChange(items)"
                  >
                    <mat-option
                      [value]="item.value"
                      *ngFor="let item of pageSizes"
                    >
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div>
              <div>
                <ngb-pagination
                  class="float-right"
                  [(page)]="page"
                  [pageSize]="pageSize"
                  [maxSize]="4"
                  [rotate]="true"
                  [ellipses]="true"
                  [collectionSize]="collectionSize"
                  (pageChange)="getAddendums()"
                ></ngb-pagination>
              </div>
            </div>

            <div style="display: flex; gap: 10px">
              <button
                class="prevButton"
                [ngStyle]="{
                  border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
                  color: page == 1 ? '#696F77' : '#34393f',
                }"
                (click)="goToPreviousPage()"
              >
                <img src="/assets/images/leftarrow.svg" />

                Previous
              </button>
              <button
                class="nextButton"
                [ngStyle]="{
                  border:
                    page == totalPages
                      ? '1px solid #E9ECEF'
                      : '1px solid #C1C6CD',
                  color: page == totalPages ? '#696F77' : '#34393f',
                }"
                (click)="goToNextPage()"
              >
                Next
                <img src="/assets/images/rightarrow.svg" />
              </button>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col">
              <ngb-pagination
                class="float-right"
                [(page)]="page"
                [pageSize]="pageSize"
                [maxSize]="4"
                [rotate]="true"
                [ellipses]="true"
                [collectionSize]="collectionSize"
                (pageChange)="getAddendums()"
              ></ngb-pagination>
            </div>
          </div> -->
        </div>
        <div
          *ngIf="filteredAddendums.length == 0 && !searchKey"
          class="noResults"
        >
          Sorry you do not have any Exception.
        </div>

        <div
          *ngIf="filteredAddendums.length == 0 && searchKey"
          class="search-empty-state"
        >
          <img
            src="/assets/images/GRBES-List.svg"
            alt=""
            class="search-empty-icon"
          />
          <h4 class="search-empty-title">No results found</h4>
          <p class="search-empty-subtitle">
            Try a different keyword or refine your search to find what you're
            looking for.
          </p>
        </div>
      </div>
    </div>
    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
  <mat-card-actions> </mat-card-actions>
</mat-card>
